import React, { useEffect, useState } from "react";
import { FormControl, Grid, MenuItem, Select } from "@mui/material";
import RevenueOccupancyChart from "./RevenueOccupancyChart";
import RepairsPieChart from './RepairsPieChart';
import CallsPieChart from './CallsPieChart';
import TasksOverviewChart from './TasksOverviewChart';
import MonthlyRevenueComparison from "./MonthlyRevenueComparision";
import { formatDate } from "../CommonFunctions";
import { categories, categorizeRepair, getCallLogsByDateRangeCalculations, getCallLogsByDateRangeInDC, getCurrentYearRevenueInDC, getFreeRoomsByDate, getRepairsByDateRangeInDC, getReportSummary } from "./DataConnections";
import { eachDayOfInterval, format, parseISO } from "date-fns";
import Header from "../Header";
const now=new Date();
now.setDate(1);
const options = { month: 'short', day: 'numeric' };
let totalThisYear = 0;
let totalLastYear = 0;
let totalRepairs = 0;
let totalCalls = 0;
let avgVacancy = 0;
let last12Months=[];
const MonthlyDashboard = () => {
    const [searchStartDate,setSearchStartDate]=  useState(formatDate(now));
      const [searchEndDate,setSearchEndDate]=useState(formatDate(new Date()));
    const [comparisionSummary, setComparisionSummary] = useState([]);
    const [callLogs,setCallLogs] = useState([]);
    const [repairs, setRepairs] = useState([]);
    const [dailyRevenueOccupancyReport, setDailyRevenueOccupancyReport] = useState([]);
    useEffect(() => {
        getRevenueSummary(null,searchStartDate,searchEndDate)
          getCallLogsByDateRange(searchStartDate,searchEndDate);
          getRepairsByDateRange(searchStartDate,searchEndDate);
        }, [searchStartDate,searchEndDate]);

    useEffect(() => {
      getLast12Months();
        getRevenueComparisions(null,searchStartDate,searchEndDate);
        

    }, []);
    function getLast12Months() {
      const months = [];
      const currentDate = new Date();
      currentDate.setDate(1); // Set to the first day of the current month
  
      for (let i = 0; i < 12; i++) {
          const startDate = new Date(currentDate);
          let endDate = new Date(currentDate);
          if(i!==0){
          endDate.setMonth(endDate.getMonth() + 1);
          endDate.setDate(0); // Set to the last day of the previous month
          }
          else{
            endDate=new Date();
          }
          
  
          months.push({
              startDate: new Date(startDate),
              endDate: new Date(endDate),
          });
  
          // Move to the previous month
          currentDate.setMonth(currentDate.getMonth() - 1);
      }
  
      last12Months= months;
  }



    const getRevenueComparisions = async(e, searchStartDate, searchEndDate) =>{
        try{
            const response  = await getCurrentYearRevenueInDC(searchStartDate, searchEndDate);
            if(response){
              console.log(response);
                setComparisionSummary(response.resultArray);
            }

        }catch(error){
            console.log(error);
        }
    }
    const getRevenueSummary = async(e, searchStartDate, searchEndDate) =>{
        try{
            const response  = await getReportSummary(e,searchStartDate, searchEndDate);
            const response2 =await getFreeRoomsByDate(searchStartDate,searchEndDate);
            const response_occupancy = response2.data;
            if(response && response_occupancy){
                // console.log(response_occupancy)
                const res=preProcessVacancyData(response_occupancy,searchStartDate,searchEndDate,response2.rooms);
                // console.log(res)
                let vacancyDict={};
                let resultArray=[];
                for(let itr in res){
                    let vacantRooms = res[itr].vacantRooms.length;
                    vacancyDict[res[itr].date] = vacantRooms;
                }
                // console.log(vacancyDict)
                for(let itr in response){
                    let crDate = response[itr].date;
                    if(crDate in vacancyDict){
                        resultArray.push({date:crDate,
                            occupancy: vacancyDict[crDate],
                            amount:response[itr].amount
                        })
                    }
                    else{
                        resultArray.push({date:crDate,
                            occupancy: 0,
                            amount:response[itr].amount
                        })

                    }
                }
                setDailyRevenueOccupancyReport(resultArray);
            }

        }catch(error){
            console.log(error);
        }
    }
    const preProcessVacancyData = (data,startDate,endDate,rooms)=>{
        let myDict={};
        let avgRooms=0;
        // console.log("start Date : " + startDate + " end date : " + endDate);
        const interval = {
          // start: new Date(startDate).toUTCString(),
          // end: new Date(endDate).toUTCString()
          start: parseISO(startDate),
          end: parseISO(endDate)
        };
        const dates = eachDayOfInterval(interval).map(date => format(date, 'yyyy-MM-dd'));
        const result = {};
        dates.forEach(date => {
          result[date] = [];
        });      
    Object.entries(data).forEach(([roomId, tenancies]) => {
      tenancies.forEach(tenancy => {
        const checkInDate = format(parseISO(tenancy.checkin), 'yyyy-MM-dd');
        let checkoutDate=null;
        if(tenancy.actualCheckoutDate===null){
    
        }
        else{
          checkoutDate = format(parseISO(tenancy.actualCheckoutDate), 'yyyy-MM-dd');
        }
    
        dates.forEach(date => {
          if(checkoutDate===null){
            if (date >= checkInDate) {
              result[date].push(parseInt(roomId));
            }
          }
          else{
            if (date >= checkInDate && date < checkoutDate) {
              result[date].push(parseInt(roomId));
            }
          }
          
        });
      });
    });
    const resultArray=[];
    avgRooms=0;
    for(let key in result){
      const occupiedRooms=result[key];
      const date=parseISO(key);
      
    
      const vacantRooms= rooms.filter(row => !occupiedRooms.includes(row.id));
      let lostRent=0;
      vacantRooms.map((row)=>{
        lostRent +=row.dailyRate;
      })
      avgRooms=avgRooms + vacantRooms.length
      resultArray.push({
        date:date.toLocaleDateString('en-US',{ month: 'short', day: 'numeric' }),
        occupiedRooms:occupiedRooms,
        vacantRooms:vacantRooms,
        lostRent:lostRent,
        numberOfVacantRooms:vacantRooms.length
      })
    
    }
    avgRooms = avgRooms/resultArray.length;
    
    console.log("Average rooms vacant: " + avgRooms)
    
    
    return resultArray;
    
      }
    const getRepairsByDateRange = async(searchStartDate,searchEndDate)=>{
        try{
            const response = await getRepairsByDateRangeInDC(searchStartDate,searchEndDate);
            if(response){
              totalRepairs = response.length;
                let resultArray=[];
            let resultDict={};
            const cats = categories;
            Object.keys(cats).forEach((key) => {
                resultDict[key]=0;
                });

                for(let itr in response){
                    const category = categorizeRepair(response[itr].description);
                    if(category in resultDict){
                        resultDict[category]+=1;
                    }
                    else{
                        resultDict[category]=1;
                    }
                }
                Object.keys(resultDict).forEach((key) => {
                resultArray.push({name: key, value:resultDict[key]})
                });
                
                setRepairs(resultArray)

            }

        }catch(error){
            console.log(error);
        }
    }
    const getCallLogsByDateRange = async(searchStartDate, searchEndDate) =>{
      try{
        const response = await getCallLogsByDateRangeCalculations(searchStartDate, searchEndDate);
        if(response){
          setCallLogs(response.resultArray);
          totalCalls= response.totalCalls;
        }
    
      }catch(error){
        console.log(error)
        
      }
    }
    function getWeeklyData(dailyData) {
    const weeks = [];
    let weekSum = 0;
    let weekOccupancy = 0;
    let weekSumLastYear=0;
    let weekStartDate = null;
    let weekEndDate = null;
    
    dailyData.forEach((entry, index) => {
        if (index % 7 === 0) {
            if (weekStartDate) {
                weeks.push({
                  date: `${weekStartDate.toLocaleDateString('en-US',options)}-${weekEndDate.toLocaleDateString('en-US',options)}`,
                    amount: weekSum,
                    lastYearAmount : weekSumLastYear,
                    occupancy: Math.floor(weekOccupancy/7)
                });
            }
            weekStartDate = new Date(entry.date);
            weekSum = 0;
            weekOccupancy =0;
            weekSumLastYear=0;
        }
        weekEndDate = new Date(entry.date);
        weekSum += entry.amount;
        weekOccupancy +=entry.occupancy;
        weekSumLastYear +=entry.lastYearAmount;
    });

    // Add the last week
    if (weekStartDate) {
        weeks.push({
            date: `${weekStartDate.toLocaleDateString('en-US',options)}-${weekEndDate.toLocaleDateString('en-US',options)}`,
            amount: weekSum,
            lastYearAmount : weekSumLastYear
        });
    }

    return weeks;
}
  return (
    <>
    <Header/>
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">
        Tidy Inn's Monthly Overview
        <FormControl sx={{ m: 1, width: 300 }}>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  onChange={(e)=>{
                    setSearchStartDate(formatDate(e.target.value.startDate))
                    setSearchEndDate(formatDate(e.target.value.endDate));
                  }}
                >
                  {last12Months.map((month)=>(
                     <MenuItem value={month}>{month.startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + " - " + 
                      month.endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</MenuItem>
                  ))}
                  </Select>
        </FormControl>
      </h1>
      <Grid container spacing={4}>
        <Grid item xs={12} md={8}>
          <RevenueOccupancyChart dailyData={dailyRevenueOccupancyReport}
          weeklyData={getWeeklyData(dailyRevenueOccupancyReport)}
          totalRevenue={totalThisYear} avgVacancy={avgVacancy}/>
        </Grid>
        <Grid item xs={12} md={4}>
          <RepairsPieChart data={repairs} totalRepairs={totalRepairs}/>
        </Grid>
        <Grid item xs={12} md={4}>
          <CallsPieChart data={callLogs} totalCalls={totalCalls}/>
        </Grid>
        {/* <Grid item xs={12} md={3.5}>
          <TasksOverviewChart />
        </Grid> */}
        <Grid item xs={12} md={8}>
          <MonthlyRevenueComparison  data={comparisionSummary} searchStartDate={searchStartDate}/>
        </Grid>
      </Grid>
    </div>
    </>
  );
};

export default MonthlyDashboard;
